var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconButtonArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.11 14.104"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6.058.004 7.052 7.048-7.052 7.052v-3.155H0V3.527h6.058Z"
})));
export default SvgIconButtonArrow;